<script setup>
defineProps({
  title: {
    type: String,
    default: ''
  },
  body: {
    type: String,
    default: ''
  }
})
</script>

<template>
  <div class="info__inner">
    <h2 class="heading">
      気象衛星（赤外）解説
    </h2>
    <div class="block">
      <div class="title">
        {{ title }}
      </div>
      <p class="text">
        {{ body }}
      </p>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.info__inner {
  display: flex;
  flex-direction: column;
  gap: 15px;
}
.heading {
  color: #303030;
  font-size: 18px;
  font-weight: bold;
  line-height: 20px;
  letter-spacing: 0.25px;
}
.block {
  display: flex;
  flex-direction: column;
  gap: 5px;
}
.title {
  color: #101010;
  font-size: 15px;
  font-weight: 600;
  line-height: 15px;
}
.text {
  color: #000;
  font-size: 15px;
  line-height: 25.05px;
}
@media (min-width: 830px) {
  .heading {
    font-size: 22px;
    line-height: 22px;
  }
}
</style>
